var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3643 2.63581C11.8495 -0.87857 6.15085 -0.878962 2.63569 2.63581C-0.879084 6.15058 -0.878692 11.8493 2.63569 15.3644C6.15046 18.8784 11.8491 18.8788 15.3643 15.3644C18.8787 11.8493 18.8783 6.15097 15.3643 2.63581ZM10.1735 12.9133C10.1735 13.5617 9.64801 14.0872 8.99961 14.0872C8.3512 14.0872 7.82567 13.5617 7.82567 12.9133V8.2175C7.82567 7.56909 8.3512 7.04356 8.99961 7.04356C9.64801 7.04356 10.1735 7.56909 10.1735 8.2175V12.9133ZM8.97887 6.21084C8.30268 6.21084 7.85189 5.73188 7.86597 5.1406C7.85189 4.52076 8.30268 4.05628 8.99256 4.05628C9.68284 4.05628 10.1195 4.52116 10.134 5.1406C10.1336 5.73188 9.68323 6.21084 8.97887 6.21084Z",
    fill: "#F9CF48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.74097ec11bcdf3d9ba4f4d0ee3b7a3db.svg";
export { ForwardRef as ReactComponent };